///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2025
//                                  RXO Inc.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of RXO Inc. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import Tooltip from "./Tooltip";

const Avatar = ({
  backgroundColor = "#EEF2FB",
  textColor = "#343434",
  fontFamily = "UniversLTPro-57Cond",
  ...props
}) => {
  let avatar = (
    <figure className={props.className} data-testid={props["data-testid"]}>
      {props.imageSource ? (
        <>
          <img
            className="round"
            src={`data:img/png;base64, ${props.imageSource}`}
            alt={props.alt}
            style={{ height: props.size, width: props.size }}
          />
          <figcaption className="accessibility">{props.alt}</figcaption>
        </>
      ) : (
        <>
          <span
            className="inline-flex items-center justify-center round text-center uppercase"
            style={{
              backgroundColor: backgroundColor,
              color: textColor,
              height: props.size,
              width: props.size,
              fontFamily: fontFamily,
              fontSize: props.fontSize
            }}
          >
            {props.textContent}
          </span>
          <figcaption className="accessibility">{props.textContent}</figcaption>
        </>
      )}
    </figure>
  );

  if (props.tooltipContent) {
    avatar = <Tooltip content={props.tooltipContent}>{avatar}</Tooltip>;
  }

  return avatar;
};

export default Avatar;
